import { gql } from '@apollo/client';

export const GET_SECTION_STATUS_QUERY = gql`
  query GetSectionStatus($section: String!) {
    getSectionStatus(section: $section) {
      status
    }
  }
`;
